<template lang="html">
  <div class="page-footer">
    <div
      ref="wrapper"
      class="page-footer__wrapper"
    >
      <div class="page-footer__body">
        <div class="page-footer__logo">
          <LogoStiftung
            v-if="logoImage === 'stiftung'"
          />
          <LogoHolding
            v-if="logoImage === 'holding'"
            :site="$route.params.country === 'ch' ? 'holding' : 'capital'"
          />
        </div>
        <div class="page-footer__content">
          <slot />
        </div>
      </div>
      <div class="page-footer__meta">
        <div class="page-footer__meta-container">
          <div class="page-footer__copyright">
            {{ copyright }}
          </div>
          <nav class="page-footer__link-nav">
            <ul
              class="page-footer__link-list"
            >
              <li
                v-for="item in items"
                :key="item.id"
                class="page-footer__link-list-item"
              >
                <AppLink
                  :is-link="!!item.targetPage.url"
                  :to="item.targetPage.url"
                  class="page-footer__link-list__text"
                >
                  {{ item.readableName }}
                </AppLink>
              </li>
            </ul>
          </nav>
        </div>
        <slot name="after" />
      </div>
    </div>
  </div>
</template>

<script>
import LogoStiftung from 'beisheim/components/elements/logo-stiftung'
import LogoHolding from 'beisheim/components/elements/logo-holding'
import AppLink from 'beisheim/components/elements/app-link'

export default {
  components: {
    LogoStiftung,
    LogoHolding,
    AppLink
  },
  props: {
    logoImage: {
      type: String,
      default: () => ''
    },
    column: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    copyright: {
      type: String,
      default: 'Beisheim Stiftung ©'
    },
    items: {
      type: Array,
      default () {
        return []
      }
    }
  },
  mounted () {
    const footerHeight = this.$refs.wrapper.offsetHeight
    this.$el.style.height = `${footerHeight}px`
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/grid';
  @import 'beisheim/scss/breakpoints';
  @import 'beisheim/scss/font';
  @import 'beisheim/scss/line-heights';

  $adress-width: grid-columns(5);

  .page-footer {
    background-color: gray(4);
  }

  .page-footer__wrapper {
    @include from(4) {
      position: fixed;
      bottom: 0;
      width: 100%;
    }
  }

  .page-footer__logo {
    width: 100%;
    max-width: 300px;
  }

  .page-footer__link-nav {
    @include from(4) {
      position: relative;
      left: scale(3) * -1;
      width: $adress-width;
    }
  }

  .page-footer__link-list-item {
    @include font(-1);

    @include to(2) {
      border-top:1px solid gray(3);
      @include grid-spacing(padding-left, 2);
      @include grid-spacing(padding-right, 2);
      padding-top: scale(4);
      padding-bottom: scale(4);
    }

    @include from(3) {
      display: inline-block;
      padding: scale(7) scale(3);
    }
  }

  .page-footer__meta-container {
    @include from(3) {
      @include grid-spacing(margin-left, 2);
      @include grid-spacing(margin-right, 2);
    }
  }

  .page-footer__copyright {
    @include to(2) {
      border-top: 1px solid gray(3);
      @include grid-spacing(padding-left, 2);
      @include grid-spacing(padding-right, 2);
      padding-top: scale(4);
      padding-bottom: scale(4);
    }

    @include from(3) {
      padding-top: scale(7);
      padding-bottom: scale(7);
    }
  }

  .page-footer__content {
    line-height: line-height(2);

    @include to(3) {
      padding-top: scale(15);
    }

    @include from(4) {
      width: $adress-width;
    }
  }

  .page-footer__body {
    display: flex;
    @include grid-spacing(margin-left, 2);
    @include grid-spacing(margin-right, 2);

    @include to(3) {
      padding-top: scale(8);
      padding-bottom: scale(8);
      flex-direction: column;
    }

    @include from(3) {
      padding-top: scale(15);
      padding-bottom: scale(40);
      justify-content: space-between;
    }
  }

  .page-footer__meta {
    @include from(3) {
      border-top: 1px solid gray(3);
    }
  }

  .page-footer__meta-container {
    margin: 0 auto;

    @include from(3) {
      @include grid-spacing(padding-left, 2);
      @include grid-spacing(padding-right, 2);
      display: flex;
      justify-content: space-between;
    }
  }
</style>
